const STATSIG_MARKETS = ['ja-jp']; // enable your market if you are using statsig.

export default function isStatSigEnabled({ locale }) {
  return STATSIG_MARKETS.includes(locale.toLowerCase());
}
